import { type UseQueryResult, useQuery } from 'react-query';
import {
  GrantAcceptanceTemplateService,
  PagedResultDto_GrantAcceptanceTemplateListDto,
} from '../../services/wealthlane-award-services';

const useGetGrantAcceptanceTemplateList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase

  PagedResultDto_GrantAcceptanceTemplateListDto | undefined,
  unknown
> => {
  //   const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const grantAcceptanceTemplateList = useQuery(['getGrantAcceptanceTemplateList'], async () => {
    return await handleRequest(
      GrantAcceptanceTemplateService.getApiAwardApiAppGrantAcceptanceTemplate()
    );
  });

  return grantAcceptanceTemplateList;
};

export default useGetGrantAcceptanceTemplateList;
